import { Component, Input, OnInit, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { BrandDisplayService } from '../../branding';
import { ReleaseVersionService, releaseVersionLine } from '../release-version.service';

@Component({
  selector: 'multisite-footer',
  templateUrl: './multisite-footer.component.html',
  styleUrls: ['./multisite-footer.component.scss'],

  standalone: false,
})
export class MultisiteFooterComponent implements OnInit {

  darkModeToggleForm : FormGroup;
  textSizeForm : FormGroup;
  @Input() logo : string; // 'culturettt' or 'icpendulum'
  @Input() summaryText : string; // 'A sentence about the site, which will not be translated'
  @Input() summaryTranslationKey : string; // 'Translation Key for a sentence about the site'
  @Input() darkModeOn: boolean; // overrides the dark mode styles for certain elements

  private releaseVersionService = inject(ReleaseVersionService);
  private translocoService = inject(TranslocoService);
  private backendVersion = toSignal(this.releaseVersionService.backend$, { initialValue: null });
  private language = toSignal(this.translocoService.langChanges$, { initialValue: this.translocoService.getActiveLang() });

  /** Which releases this page runs on, for support; hidden when printing. */
  versionLine = computed(() => releaseVersionLine(this.releaseVersionService.frontend, this.backendVersion(), this.language()));

  constructor(
    private brandDisplayService : BrandDisplayService
  ) { }

    getYear(){
      return new Date().getFullYear();
    }

  ngOnInit(): void {
    this.darkModeToggleForm = new FormGroup({
      mode: new FormControl(this.brandDisplayService.darkMode, [Validators.required])
    });
    this.darkModeToggleForm.controls.mode.valueChanges.subscribe(
      (value) => {
       this.brandDisplayService.darkMode = value;
      }
    );
    this.textSizeForm = new FormGroup({
      size: new FormControl(this.brandDisplayService.textSize)
    });
    this.textSizeForm.controls.size.valueChanges.subscribe(
      (value) => {
       this.brandDisplayService.textSize = value;
      }
    );
  }

}
